<script setup lang="ts">
import type MatrixStationRoleCell from '../classes/MatrixStationRoleCell';
import type MatrixRow from '../classes/MatrixRow';
import MatrixCellShootingRenderer from './MatrixStationRoleCellRenderers/MatrixCellShootingRenderer.vue';
import MatrixCellTimeRenderer from './MatrixStationRoleCellRenderers/MatrixCellTimeRenderer.vue';
import { computed } from 'vue';

const props = defineProps<{ value: MatrixStationRoleCell; row: MatrixRow }>();

/**
 * Array of the shots.
 * Misses are true, hits are false.
 */
const misses = computed(() => {
    // If we have a ShootingResult we have the hits and misses in the correct order
    if (props.value.ShootingResult) {
        return props.value.ShootingResult.Misses;
    }

    // Null means we havent shot yet.
    return null;
});
</script>
<template>
    <MatrixCellTimeRenderer
        v-if="!value.IsShooting"
        :matrixStationRoleCell="value"
        :row
    />

    <MatrixCellShootingRenderer
        v-else
        :misses="misses"
        :lane="value.ShootingResult?.Lane"
        :penaltyLapCount="value.PenaltyLapCount"
        :backupMissesCount="value.BackupShootingMisses"
        :biathlonPictureRelativeUrl="value.BiathlonPictureRelativeUrl"
        :hideBiathlonPicture="row.MatrixConfig.HideBiathlonPictures"
        :warningsAcknowledgedByName="value.ShootingWarningsAcknowledgedmentByName"
        :hasBackupMissesWarning="value.HasBackupMissesWarning"
        :hasPenaltyLapWarning="value.HasPenaltyLapWarning"
    />
</template>
